module.exports = __webpack_public_path__ + "media/images/icons/filled/right-circle-a3fedadc88e0e952b2df8174389c8dd5.svg";